
if ($(".cs-custom-form1").find('input[type="checkbox"]').length > 0) {
	$.each($(".cs-custom-form1").find('input[type="checkbox"]'), function (index, chk) {
		$(chk).parent().addClass('chkLabel');
	});
}
if ($(".cs-custom-form1").find('input[type="radio"]').length > 0) {
	$.each($(".cs-custom-form1").find('input[type="radio"]'), function (index, chk) {
		$(chk).parent().addClass('chkLabel');
		$(chk).parent().parent().css('display', 'inline-flex');
	});
}

function saveContactForm(t) {};
$(document).ready(function() {
  $(".cs-custom-form1 > form").on('submit', function (e) {
    e.preventDefault();
    $("#msg").html('');
    $("#msg").removeClass('success-msg');
    $("#msg").removeClass('error-msg');
    $('#loadingImg').remove();
    // let form = $(t).parents('form');
    let form = $(this);
    let form_id = $(form).attr('id');
    let action = $(form).attr('action');
    var button = $(form).find('[type="submit"]');

    let formData = new FormData($('#' + form_id)[0]);
    formData.append('form_id', form_id);

    if ($(form).find(".g-recaptcha").length > 0 && $(form).find(".g-recaptcha").attr('data-sitekey').length > 0 && grecaptcha !== undefined && grecaptcha.getResponse() == '') {
      $("#msg").html('Please verify google recaptcha.');
      $("#msg").addClass('error-msg');
      return false;
    }

    if (typeof csFormBeforeSend !== 'undefined' && typeof csFormBeforeSend === 'function') {
      if (csFormBeforeSend(form_id, $(form).serialize()) === false) {
        $("#msg").addClass('error-msg');
        return false;
      }
    }

    $(form).find("button[type='submit']").attr('disabled', 'disabled');

    $.ajax({
      url: action,
      type: 'POST',
      dataType: "JSON",
      data: formData,
      processData: false,
      contentType: false,
      crossDomain: true,
      beforeSend: function (xhr) {
        //xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
        //xhr.setRequestHeader("Access-Control-Allow-Methods", "*");
        button.closest('div').append('<svg id="loadingImg" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" width="30px" height="30px" viewBox="0 0 128 128" xml:space="preserve"><rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF" /><g><path fill="#000000" d="M109.25 55.5h-36l12-12a29.54 29.54 0 0 0-49.53 12H18.75A46.04 46.04 0 0 1 96.9 31.84l12.35-12.34v36zm-90.5 17h36l-12 12a29.54 29.54 0 0 0 49.53-12h16.97A46.04 46.04 0 0 1 31.1 96.16L18.74 108.5v-36z"/><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="800ms" repeatCount="indefinite"></animateTransform></g></svg>');
      },
      success: function (data) {
        $(form).find("button[type='submit']").removeAttr('disabled');
        $("#msg").insertAfter($(form).find('button[type="submit"]'));
        if (data.status === 'success') {
          if (typeof csFormSuccessCallback !== 'undefined' && typeof csFormSuccessCallback === 'function') {
            if (csFormSuccessCallback(form_id, data) === false) {
              return false;
            }
          }
          $('#' + form_id)[0].reset();
          if ($(form).find(".g-recaptcha").length > 0 && $(form).find(".g-recaptcha").attr('data-sitekey').length > 0 && grecaptcha !== undefined) {
            grecaptcha.reset();
          }
          if (data.url !== undefined && data.url !== null && data.url !== '') {
            // window.open(data.url, "_blank");
            location.href = data.url;
          } else {
            $("#msg").html(data.message);
          }
          $("#msg").addClass('success-msg');
          setTimeout(function () {
            if ($("#viewFormModal").length > 0) {
              $("#viewFormModal").modal('hide');
            }
          }, 3000);
        }
        else {
          $("#msg").html(data.message);
          $("#msg").addClass('error-msg');
        }
        setTimeout(function () {
          $("#msg").html('');
        }, 10000);
      },
      error: function (error) {
        console.log(error);
      }
    }).done(function(){
      $('#loadingImg').remove();
    });
  });
});